import React from 'react';
import useSceneActivity from './useSceneActivity.web';

function Steam({ x, y }) {
  return <g transform={`translate(${x} ${y})`}>
    {[0, 1, 2].map(i => <path key={i} data-moment-steam="true" d="M0 0v-8h-3v-8h3v-8h3v-6" fill="none" stroke="#fff5dc" strokeWidth="2.5" style={{ animationDelay: `${-i * 1.8}s` }} />)}
  </g>;
}

function Leaves({ x, y, warm = false }) {
  return <g transform={`translate(${x} ${y})`}>
    {[0, 1].map(i => <g key={i} transform={`translate(${i * 62} ${i % 2 * 28})`}>
      <path data-moment-leaf="true" d="M0 0h7v3h4v7H4V7H0z" fill={warm ? '#d6ba5b' : '#a6c764'} style={{ animationDelay: `${-i * 4}s`, animationDuration: `${18 + i * 2}s` }} />
    </g>)}
  </g>;
}

function Ripples({ x, y, width = 250, height = 25 }) {
  return <g transform={`translate(${x} ${y})`}>
    {Array.from({ length: 7 }, (_, i) => <rect key={i} data-pixel-ripple="true" x={(i * 67) % width} y={(i * 13) % height} width={7 + i % 4 * 4} height="2" fill="#d1edeb" style={{ animationDelay: `${-i * .7}s`, animationDuration: `${4 + i % 3}s` }} />)}
  </g>;
}

/** Match the source image's coordinates; no camera movement or character warping. */
export default function MomentAtmosphere({ scene }) {
  const activityRef = useSceneActivity();
  return <svg ref={activityRef} data-scene-active="false" data-pixel-scene="true" data-moment-atmosphere={scene} aria-hidden="true" focusable="false" viewBox="0 0 1916 821" preserveAspectRatio="xMidYMid meet" style={{ position: 'absolute', width: '100%', height: '100%', pointerEvents: 'none' }}>
    <g shapeRendering="crispEdges">
      {scene === 'family' && <>
        <Leaves x={140} y={70} />
        <Ripples x={270} y={303} width={290} height={28} />
        <Steam x={1674} y={315} />
      </>}
      {scene === 'picnic' && <>
        <Ripples x={842} y={369} width={142} height={22} />
        <Leaves x={58} y={145} />
      </>}
      {scene === 'garden' && <>
        <Leaves x={1430} y={78} warm />
        <Steam x={1727} y={387} />
        <g fill="none" stroke="#e3f6f4" strokeWidth="2" strokeDasharray="3 7" opacity=".45">
          {[0, 1, 2, 3, 4].map(i => <path key={i} data-moment-water="true" d={`M${1249 + i * 3} ${496 + i * 2}l${8 + i * 6} ${29 + i * 3}`} style={{ animationDelay: `${-i * .17}s` }} />)}
        </g>
      </>}
      {[0, 1, 2].map(i => <rect key={i} data-pixel-firefly="true" x={160 + i * 760} y={650 + i % 3 * 36} width="3" height="3" fill="#ffe7a2" style={{ animationDelay: `${-i * 2.4}s`, animationDuration: `${11 + i}s` }} />)}
    </g>
  </svg>;
}
